export default "__VITE_ASSET__DgMngf_E__"